import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const wallabag = defineConnector({
  identifier: "wallabag",
  name: "Wallabag",
  tagLine: "Self-hosted read-it-later service",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Set up API access",
      items: [
        {
          kind: "markdown",
          content:
            "In Wallabag, go to **API clients management** and create a new client. Then use the OAuth flow to obtain an access token.",
        },
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://wallabag.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Wallabag instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/user.json`,
  },
});
